import GroupIcon from '@mui/icons-material/Group';

import {
  FilterFieldContainer,
  FilterLabel,
  RangeInput,
  RangeInputContainer,
  RangeInputField,
  RangeInputIcon,
} from '../GeneratikTableFilterPanel.styles';
import { NumberRangeFieldProps } from '../GeneratikTableFilterPanel.types';
import { formatFilterNumber, parseFilterNumber } from './filterNumber';

const NumberRangeFilterField = ({ field, value, onChange, t, disabled }: NumberRangeFieldProps) => (
  <FilterFieldContainer>
    <FilterLabel>{field.label}</FilterLabel>
    <RangeInputContainer data-testid={`filter-field-${field.id}`}>
      <RangeInput>
        <RangeInputIcon>{field.icon || <GroupIcon />}</RangeInputIcon>
        <RangeInputField
          type="text"
          placeholder={t('Min')}
          value={formatFilterNumber(value.min || '')}
          onChange={(e) => onChange({ ...value, min: parseFilterNumber(e.target.value) })}
          disabled={disabled}
        />
      </RangeInput>
      <RangeInput>
        <RangeInputIcon>{field.icon || <GroupIcon />}</RangeInputIcon>
        <RangeInputField
          type="text"
          placeholder={t('Max')}
          value={formatFilterNumber(value.max || '')}
          onChange={(e) => onChange({ ...value, max: parseFilterNumber(e.target.value) })}
          disabled={disabled}
        />
      </RangeInput>
    </RangeInputContainer>
  </FilterFieldContainer>
);

export default NumberRangeFilterField;
